module.exports = __webpack_public_path__ + "img/avatar.aa6433e5.svg";